import { useSnapshot } from 'valtio'
import * as React from 'react'
import { useRef } from 'react'
import '../SafeZone.css'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import { editStyle, getDefaultSafeZoneCoords } from '../helpers/safeZoneHelper.ts'
import { SafeZonePolygon } from '../mapComponents/SafeZonePolygon.tsx'
import { safeZoneState, setNewSafeZone } from '../../../store/safeZoneState.ts'
import { getCenterOfSafeZone } from '../../map/mapHelpers.tsx'
import { mapState } from '../../../store/mapState.ts'
import { LatLng } from '../../map/types.ts'
import { SafeZoneInstructions } from './Instructions.tsx'
import PlaceResult = google.maps.places.PlaceResult

interface Props {
    placeholder: string
}

export const MapSearchBox: React.FC<Props> = (props) => {
    const inputRef = useRef<HTMLInputElement>(null)
    const map = (useSnapshot(mapState) as typeof mapState).map
    const placeChanged = (place: PlaceResult[] | undefined) => {
        if (place?.[0]?.geometry && map) {
            const placeCenter = {
                lat: place[0].geometry.location?.lat(),
                lng: place[0].geometry.location?.lng()
            }
            if (placeCenter.lat && placeCenter.lng) {
                map.setCenter(placeCenter as LatLng)
                const coords = getDefaultSafeZoneCoords(placeCenter.lat, placeCenter.lng)
                const poly = <SafeZonePolygon isNew={true} coords={coords} options={editStyle}/>
                // TODO: Make function to update properties in the store
                safeZoneState.newSafeZoneGeometry = coords
                setNewSafeZone(poly)
                safeZoneState.instructions = null
                safeZoneState.view = 'finish'

                const center = getCenterOfSafeZone(coords)
                map.panTo(center as LatLng)
                map.setZoom(18)
            }
        }
    }

    React.useEffect(() => {
        if (inputRef.current) {
            const searchBox = new google.maps.places.SearchBox(inputRef.current)
            searchBox.addListener('places_changed', () => {
                if (placeChanged) {
                    placeChanged(searchBox.getPlaces())
                }
            })
            return () => google.maps.event.clearInstanceListeners(searchBox)
        }
        safeZoneState.instructions = SafeZoneInstructions.ADDRESS
    }, [])

    const clear = () => {
        if (inputRef.current) {
            inputRef.current.value = ''
        }
    }

    const doCancel = () => {
        safeZoneState.instructions = null
        safeZoneState.view = 'list'
    }

    const cancel = (
        <div className={'flex justify-start gap-6 items-center'}>
            <button className={'btn btn-ghost text-secondary'} onClick={doCancel}>
                cancel
            </button>
        </div>
    )

    const searchField = (
        <div className={'flex flex-col gap-2 justify-start items-center relative w-full'}>
            <div className={'mt-4'}>
                {cancel}
            </div>
            {/*<div className={'w-full px-4'}>*/}
                <input className={'gibi-input w-full text-base-content focus:outline-0'} ref={inputRef} {...props}
                       type={'text'}/>
        {/*</div>*/}
            <div>
                <div className={'absolute top-3 right-6 opacity-50'} onClick={clear}>
                    <HighlightOffIcon sx={{width: '18px', height: '18px'}}/>
                </div>
            </div>
        </div>
    )

    return searchField
}